import React from "react";
import tableIcons from "./MaterialTableIcons";
import { TablePagination } from "@material-ui/core";
import CustomLoader from "../CustomLoader";
import MaterialTable, {
  MaterialTableProps,
  MTableToolbar,
} from "material-table";

const OverlayLoadingComponent: React.FC = () => <></>;

const defaultHeaderStyle = {
  color: "#203A75",
  fontWeight: "bold",
  fontSize: "12px",
  whiteSpace: "nowrap",
  center: true,
} as React.CSSProperties;

const defaultRowStyle = {
  whiteSpace: "nowrap",
  fontSize: "12px",
} as React.CSSProperties;

const EmptyIcon: React.FC = () => <div />;

interface ITablePagination {
  ActionsComponent?: React.ComponentType<any>;
  onChangePage?: any;
  onChangeRowsPerPage?: any;
  count: number;
  page: number;
  rowsPerPage: number;
}

const PatchedPagination: React.FC<ITablePagination> = ({
  ActionsComponent,
  onChangePage,
  onChangeRowsPerPage,
  count,
  page,
  rowsPerPage,
  ...rest
}) => {
  const WrappedActions = ActionsComponent
    ? (subprops: any) => {
        const { onPageChange: innerPageChange, ...actionsProps } = subprops;
        return (
          <ActionsComponent {...actionsProps} onChangePage={innerPageChange} />
        );
      }
    : undefined;

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onChangePage}
      onRowsPerPageChange={onChangeRowsPerPage}
      ActionsComponent={WrappedActions}
      SelectProps={{ IconComponent: EmptyIcon }}
      {...rest}
    />
  );
};

interface IReportMaterialTable extends MaterialTableProps<object> {
  showTitle?: boolean;
  showHeader?: boolean;
  headerStyle?: React.CSSProperties;
  rowStyle?: React.CSSProperties;
  showToolbar?: boolean;
  toolbarSearch?: boolean;
  searchFieldAlignment?: "left" | "right";
  paging?: boolean;
  pageSize?: number;
  exportButton?: boolean;
}

const ReportMaterialTable: React.FC<IReportMaterialTable> = ({
  data,
  isLoading,
  columns,
  showTitle = false,
  toolbarSearch,
  showHeader = true,
  headerStyle = defaultHeaderStyle,
  rowStyle = defaultRowStyle,
  showToolbar = false,
  searchFieldAlignment = "left",
  tableRef,
  paging = true,
  pageSize = 10,
  exportButton,
  ...props
}) => {
  return (
    <div>
      <MaterialTable
        data={data}
        isLoading={isLoading}
        columns={columns}
        options={{
          header: showHeader,
          exportButton: exportButton
            ? { csv: exportButton, pdf: false }
            : false,
          search: toolbarSearch,
          showTitle: showTitle,
          searchFieldAlignment: searchFieldAlignment,
          headerStyle: headerStyle,
          toolbar: showToolbar,
          rowStyle: rowStyle,
          padding: "dense",
          paging: paging,
          pageSize: pageSize,
          pageSizeOptions: [10, 20, 30, 40, 50],
          showTextRowsSelected: false,
        }}
        localization={{
          body: {
            emptyDataSourceMessage: isLoading ? (
              <CustomLoader />
            ) : (
              <span style={{ fontSize: "14px" }}>No records to display.</span>
            ),
          },
        }}
        components={{
          Pagination: PatchedPagination,
          OverlayLoading: OverlayLoadingComponent,
        }}
        style={{ overflowX: "auto" }}
        icons={tableIcons}
        tableRef={tableRef}
        {...props}
      />
    </div>
  );
};

export default ReportMaterialTable;
